/**
 * Settings -- placeholder.
 *
 * SHELL-060 to SHELL-065 need somewhere to persist to, which is SDD-003 and
 * `platform/storage.ts`, neither of which exists. A toggle that forgets itself
 * on reload is worse than no toggle: it looks like a bug in persistence rather
 * than an unbuilt screen.
 */

import { Screen } from '@shell/Screen';
import { routes } from '@shell/routes';

export function Settings() {
  return (
    <Screen title="Settings">
      <p>Settings are not built yet. They arrive with save data.</p>
      <nav class="screen-nav">
        <a class="nav-link" href={routes.picker()}>
          Back to the game picker
        </a>
      </nav>
    </Screen>
  );
}
